import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

interface RadioButtonsGroupProps {
	id?: 'radio-group';
	defaultValue?: string;
	label?: string;
	radioButtons: any[];
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButtonsGroup: React.FC<RadioButtonsGroupProps> = ({
	id,
	defaultValue,
	label,
	radioButtons,
	onChange,
}) => {
	return (
		<FormControl>
			{label && <FormLabel id={id}>{label}</FormLabel>}
			<RadioGroup
				aria-labelledby={id}
				value={defaultValue}
				name={`radio-buttons-group-${id}`}
				onChange={onChange}
				row
			>
				{radioButtons.map((radio) => (
					<FormControlLabel
						key={radio.value}
						value={radio.value.toString()}
						control={<Radio />}
						label={radio.label}
					/>
				))}
			</RadioGroup>
		</FormControl>
	);
};

export default RadioButtonsGroup;
